import { useTab } from '@react-aria/tabs'
import { TabListState } from '@react-stately/tabs'
import cx from 'classnames'
import Styles from './Tab.module.scss'
import { useObjectRef } from 'utils/useObjectRef'
import { Node } from '@react-types/shared'
import SelectedTriangle from './SelectedTriangle'
import { useHeaderTheme } from 'hooks/useHeaderTheme'

interface Props<T> {
  item: Node<T>
  state: TabListState<T>
  className?: string
  withEditorTopColor?: boolean
}

export const Tab = <T,>({ item, state, className, withEditorTopColor = false }: Props<T>) => {
  const { key, rendered } = item
  const ref = useObjectRef<HTMLDivElement>()
  const { tabProps } = useTab({ key }, state, ref)
  const isSelected = state.selectedKey === key
  const isDisabled = state.disabledKeys.has(key)
  const theme = useHeaderTheme()

  return (
    <div
      {...tabProps}
      ref={ref}
      className={cx(Styles.tab, className, {
        [Styles.selected]: isSelected,
        [Styles.withEditorTopColor]: withEditorTopColor,
        [Styles.disabled]: isDisabled,
      })}
    >
      {rendered}
      {isSelected && withEditorTopColor && theme === 'dark' && (
        <div className={Styles.arrow}>
          <SelectedTriangle color="#EAF9FB" />
        </div>
      )}
    </div>
  )
}
